export default class ComponentObserver {

    private static subscription: any;
    private static controls: KnockoutObservableArray<string> = ko.observableArray([]);
    private static computed: KnockoutComputed<Array<string>> = ko.computed(() => { return ComponentObserver.controls(); }).extend({ throttle: 100 });
    private static defs: Array<JQueryDeferred<any>> = [];

    public static onControlInit(identifier: string) {
        ComponentObserver.createSubscription();
        ComponentObserver.controls.push(identifier);
    }

    public static onControlReady(identifier: string) {
        ComponentObserver.controls.splice(ComponentObserver.controls.indexOf(identifier), 1);
    }

    private static createSubscription() {
        if (ComponentObserver.subscription == undefined)
            ComponentObserver.subscription = ComponentObserver.computed.subscribe(() => { if(ComponentObserver.computed()?.length == 0)  ComponentObserver.resolveAllDeferreds() });
    }

    private static resolveAllDeferreds() {
        ComponentObserver.defs.forEach((d) => d.resolve());
        ComponentObserver.defs = [];
    }

    public static whenAllComponentsAreReady(): JQueryPromise<boolean> {
        var d = $.Deferred();

        ComponentObserver.defs.push(d);

        return d.promise();
    }
}